const privacyPolicy = [
    { 
        id: "overview", 
        title: "1. Overview", 
        content: "At [Your Car Dealership Name], we prioritize your privacy and security while providing high-quality automotive services. This Privacy Policy explains how we collect, use, and safeguard your personal information in relation to our car sales and services."
    },
    { 
        id: "data-privacy", 
        title: "2. Data Privacy", 
        content: "We collect essential data to offer our car dealership services, including:",
        list: [
            "Customer details and contact information for communication",
            "Vehicle purchase history and financing details",
            "Service appointment information and maintenance records",
            "Payment details for transactions and financing purposes"
        ]
    },
    { 
        id: "terms-of-service", 
        title: "3. Terms of Service", 
        content: "Our Terms of Service govern the use of our car dealership services, including vehicle sales, service bookings, and financing options. By using our services, you agree to comply with these terms, including payment conditions and warranty policies."
    },
    { 
        id: "user-rights", 
        title: "4. User Rights", 
        content: "You have the right to:",
        list: [
            "Access and manage your personal and vehicle-related information",
            "Request updates or deletions of personal data stored with us",
            "Review and manage your service and financing agreements"
        ]
    },
    { 
        id: "data-security", 
        title: "5. Data Security", 
        content: "We implement stringent security protocols to protect your personal and financial data, including encryption and secure storage systems, ensuring unauthorized access is prevented."
    },
    { 
        id: "cookies", 
        title: "6. Cookies", 
        content: "Our website uses cookies to enhance your browsing experience, such as remembering your login details and analyzing website traffic for improvements in our services."
    },
    { 
        id: "third-party", 
        title: "7. Third-Party Services", 
        content: "We may partner with third-party service providers for tasks such as payment processing and vehicle financing. These partners are carefully chosen to ensure they meet the highest privacy and security standards."
    },
    { 
        id: "data-storage", 
        title: "8. Data Storage", 
        content: "We store customer data and vehicle records securely. Data retention periods vary based on service agreements and legal requirements. You may request customized data storage options to meet your needs."
    },
    { 
        id: "data-transfers", 
        title: "9. Data Transfers", 
        content: "In some cases, we may need to transfer data to external systems or third-party vendors for processing, such as financing approvals. All data transfers comply with applicable laws to ensure your information remains secure."
    },
    { 
        id: "policy-updates", 
        title: "10. Policy Updates", 
        content: "We regularly update this Privacy Policy to reflect changes in our services or applicable regulations. You will be notified of any significant updates, and the most current version will always be available on our website."
    }
];

export default privacyPolicy;